import apiClient from '@/utils/request'
import {
  IRespondedJobResponse,
  IRespondedJobParams
} from '@/interfaces/respondedJobs'

export const fetchItem = async (id: number): Promise<IRespondedJobResponse> => {
  const response = await apiClient.get<IRespondedJobResponse>(
    `/responded_jobs/${id}`
  )
  return response.data
}

export const createItem = async (
  params: IRespondedJobParams
): Promise<IRespondedJobResponse> => {
  const response = await apiClient.post<IRespondedJobResponse>(
    '/responded_jobs',
    params
  )
  return response.data
}
